<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import AccountLayout from '@/layouts/AccountLayout.vue'
import ChatLayout from '@/layouts/ChatLayout.vue'
import DocsLayout from '@/layouts/DocsLayout.vue'
import ToastContainer from '@/components/ToastContainer.vue'

const route = useRoute()

// Карта макетов
const layouts = {
  DefaultLayout,
  AuthLayout,
  AccountLayout,
  ChatLayout,
  DocsLayout
}

// Определяем какой layout использовать на основе метаданных маршрута
const currentLayout = computed(() => {
  const layoutName = route.meta?.layout || 'DefaultLayout'
  return layouts[layoutName as keyof typeof layouts]
})
</script>

<template>
  <div id="app">
    <component :is="currentLayout">
      <router-view />
    </component>
    
    <!-- Глобальный контейнер для уведомлений -->
    <ToastContainer />
  </div>
</template>